import React, { useContext, useEffect, useLayoutEffect, useRef } from 'react'
import { Grid, Stack, Typography, useMediaQuery } from '@mui/material';
import { TypeAnimation } from 'react-type-animation';
import WavingHandIcon from '@mui/icons-material/WavingHand';
import { motion } from 'framer-motion'
import { ThemeContext } from '../Context/ThemeContext';

function Home() {
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down('sm'));
  const {mode} = useContext(ThemeContext);
  const home = useRef(null);
  useLayoutEffect(() => {
    const setFullHeight = () => {
      if (home.current) {
        home.current.style.minHeight = window.innerHeight + 'px';
      }
    };

    setFullHeight(); // Set initially

    // Recalculate on window resize
    window.addEventListener('resize', setFullHeight);

    return () => {
      window.removeEventListener('resize', setFullHeight);
    };
  }, []);
  return (
      <Grid id='home' container p={5} justifyContent={"space-between"} alignItems={"center"} sx={{ height: "100vh", minHeight: "-webkit-fill-available" }} ref={home}>
        <Grid item xl={8} lg={8} sm={12} xs={12} height={{ xs: "10%", lg: "auto" }}>
          <Typography variant='h3' fontSize={{ xs: "2rem", lg: "3rem" }} color="primary" sx={{fontWeight: '700' }}>Hello <WavingHandIcon sx={{ color: '#FFCE48' }} fontSize='large' />,</Typography>
          <Typography variant='h3' fontSize={{ xs: "2rem", lg: "3rem" }} color="primary" sx={{fontWeight: '700' }}>My Name is</Typography>
          <Typography variant='h3' fontSize={{ xs: "2rem", lg: "3rem" }} sx={mode ? {fontWeight: '700', color: "#e5e5e5"} : { fontWeight: '700', background: 'linear-gradient(to right, #1aacf3, #289ef0, #3f8feb, #567fe2, #6b6dd6)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent' }}>Sidul Islam Moon</Typography>
          <Typography variant='h3' fontSize={{ xs: "2rem", lg: "3rem" }} color="primary" sx={{fontWeight: '700' }}>
            <TypeAnimation
              sequence={[
                // Same substring at the start will only be typed out once, initially
                'I am a Mern Stack Developer',
                1000, // wait 1s before replacing "Mice" with "Hamsters"
                'I am a React.js Developer',
                1000,
                'I am a Node.js Developer',
                1000,
              ]}
              wrapper="span"
              speed={50}
              style={{ display: 'inline-block' }}
              repeat={Infinity}
            />
          </Typography>
        </Grid>
        <Grid item xl={4} lg={4} sm={12} xs={12}>
        <motion.div
          initial={{ opacity: 1, scale: 0.9 }}
          animate={{ opacity: 1, scale: [0.9, 1, 0.9] }}
          transition={{
            duration: 2,
            times: [0, 0.5, 1],
            ease: 'easeInOut',
            repeat: Infinity,
          }}
        >
          <lottie-player src="https://lottie.host/bfc32dbf-c855-4a0e-9ae4-5aec8f5f775f/HyW91OERsb.json" background="#FFFFFF" speed="1" style={{ width: '100%', height: '300px' }} loop autoplay direction="1" mode="normal"></lottie-player>
        </motion.div>
        </Grid>
      </Grid>
  )
}

export default Home